var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-filter-advanced-group',{attrs:{"title":"Artists","count":_vm.count}},[_c('core-filter-input-suggest',{attrs:{"placeholder":"Start typing a artist's name...","toggle":true,"field":"artist_name","filter":_vm.value('artists'),"api":"artists/suggest","data":"artists"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }